import { render, staticRenderFns } from "./UserManagementHelp.vue?vue&type=template&id=487f72c3&scoped=true"
import script from "./UserManagementHelp.vue?vue&type=script&lang=js"
export * from "./UserManagementHelp.vue?vue&type=script&lang=js"
import style0 from "./UserManagementHelp.vue?vue&type=style&index=0&id=487f72c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487f72c3",
  null
  
)

export default component.exports